import {
  CHECPLUS_MODULE_NAMES,
  ASSIGNED,
  O_MAP,
  AS_BUILT,
} from 'utils/constants'

const { freeze } = Object

const { XMC3, XMC4, XMC5, XMC6 } = CHECPLUS_MODULE_NAMES

export const MODULE_NAME_INTERFACE = 'interface'
export const INTERFACE_KEY = 'INTERFACE'
export const N_A = 'N/A'
export const interfaceLocations = freeze({
  INT: 'INT',
  EXT: 'EXT',
})

export const interfaceConnectorsWithNames = ['5', '6']

export const xmcConnectors = freeze({
  X1: 'X1',
  X2: 'X2',
  X3: 'X3',
})

export const interfaceConnectors = freeze({
  EXT1: 'EXT1',
  INT1: 'INT1',
  EXT2: 'EXT2',
  INT2: 'INT2',
  EXT3: 'EXT3',
  INT3: 'INT3',
  EXT4: 'EXT4',
  INT4: 'INT4',
  INT6: 'INT6',
  EXT6: 'EXT6',
  INT5: 'INT5',
  EXT5: 'EXT5',
})

export const allowedModules = freeze([XMC3, XMC4, XMC5, XMC6])
export const showInterfaceColumn = freeze([XMC3, XMC4, XMC5, XMC6])
export const showSourceColumn = freeze([MODULE_NAME_INTERFACE])

export const MOVEABLE_PIN_STATUSES = new Set([ASSIGNED, O_MAP, AS_BUILT])
